//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../Features/Features.ShipDesign.DrawingTemplateBuilder.js";
import "../no/SelectDatumPlaneList.js";
import "../Features/Features.ShipDesign.ShipStructureBuilder.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"AdditionalStructures",0,"SelectNXObjectList",1],[0,"BackProximity",1,0],[0,"DrawingName",1,0],[0,"DrawingSheet",1,"Features.ShipDesign.DrawingSheetBuilder",0],[1,"DrawingTemplate",0,"Features.ShipDesign.DrawingTemplateBuilder",0],[0,"FlipViewDirection",1,0],[0,"FrontProximity",1,0],[1,"HiddenObjects",0,"SelectNXObjectList",1],[0,"Margin",1,0],[0,"Offset",1,0],[0,"PlaneType",1,0],[0,"SectionPlane",1,"Plane",0],[0,"SectionPlaneName",1,0],[0,"SectionRule",1,0],[1,"SelectFrame",0,"SelectDatumPlaneList",0],[0,"SheetScale",1,0],[1,"ShipStructure",0,"Features.ShipDesign.ShipStructureBuilder",0],[0,"SymmetricalStructure",1,0],[0,"ViewName",1,0],[0,"XPosition",1,0],[0,"YPosition",1,0]],[[[],"GetViewDirection",{R_:{viewDirection:''}},0,0]],[]];
SPLM.Features.ShipDesign.SectionViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SectionViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.SectionViewBuilder.PlaneTypes = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "UserSpecified" : "UserSpecified"});

SPLM.Features.ShipDesign.SectionViewBuilder.DirectionOptions = Object.freeze({
    "Fw" : "Fw", "Af" : "Af", "In" : "In", "Ot" : "Ot", "P" : "P", "S" : "S", "Up" : "Up", "Dn" : "Dn"});

SPLM.Features.ShipDesign.SectionViewBuilder.SymmetricalStructureOptions = Object.freeze({
    "Full" : "Full", "Port" : "Port", "Starboard" : "Starboard"});

SPLM.Features.ShipDesign.SectionViewBuilder.SectionRuleOptions = Object.freeze({
    "ByRule" : "ByRule", "SimpleSection" : "SimpleSection"});

export default SPLM;